import { Modal, Button } from "react-bootstrap";
import { useEffect, useState } from "react";

const SuccessAssignTaskModal = ({ show, handleClose, res, _setRes }) => {
  const length = res?.length || 0;

  const [timer, setTimer] = useState(5);
  const [progress, setProgress] = useState(0);
  const [progressPercent, setProgressPercent] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    let interval;

    if (show) {
      setTimer(5);
      setProgress(0);
      setProgressPercent(0);
      setIsComplete(false);
      const startedAt = Date.now();
      const progressDuration = 4000;
      const closeDuration = 5000;

      interval = setInterval(() => {
        const elapsed = Date.now() - startedAt;
        const percentage = Math.min(elapsed / progressDuration, 1);

        setProgress(Math.min(Math.floor(length * percentage), length));
        setProgressPercent(percentage * 100);
        setTimer(Math.max(Math.ceil((closeDuration - elapsed) / 1000), 0));

        if (percentage === 1) setIsComplete(true);

        if (elapsed >= closeDuration) {
          clearInterval(interval);
          handleClose();
        }
      }, 50);
    }

    return () => {
      clearInterval(interval);
    };
  }, [show, handleClose, length]);

  if (!show) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      keyboard={false}
      centered
      style={{ zIndex: 100000 }}
      dialogClassName="assign-task-popup modal-dialog modal-md modal-dialog-centered max-800p-case-nav custom-insurance-dialog"
    >
      <Modal.Header className="text-center p-0 bg-primary popup-heading-color justify-content-center modal-header">
        <Modal.Title className="mx-auto font-size-24 height-35 font-weight-semibold text-uppercase popup-heading-color font-weight-500">
          Tasks have been Assigned
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="overflow-x-hidden overflow-y-scroll invisible-scrollbar p-l-5 p-t-5 p-r-5 p-b-5"
        style={{ minHeight: "90px" }}
      >
        <div className="d-flex flex-column align-items-center justify-content-center">
          <span
            style={{
              fontWeight: "600",
              color: "var(--primary)",
            }}
            className="m-t-5 whitespace-nowrap"
          >
            {isComplete
              ? `${length} task${length !== 1 ? "s" : ""} successfully assigned`
              : `Assigning tasks to ${length} case worker${length !== 1 ? "s" : ""}:`}
          </span>
          <span
            style={{
              fontWeight: "600",
              color: "var(--primary)",
            }}
            className="whitespace-nowrap"
          >
            {isComplete
              ? `Complete. Closing in ${timer} second${timer !== 1 ? "s" : ""}...`
              : `Popup will automatically close in ${timer} seconds...`}
          </span>
          <div
            className="w-100 overflow-hidden"
            style={{
              height: "8px",
              marginTop: "5px",
              borderRadius: "4px",
              background: "var(--primary-10)",
            }}
          >
            <div
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={length}
              aria-valuenow={progress}
              style={{
                width: `${progressPercent}%`,
                height: "100%",
                borderRadius: "4px",
                background: "var(--primary)",
                transition: "width 50ms linear",
              }}
            />
          </div>
          <span style={{ color: "var(--primary)", fontWeight: "600" }}>
            {progress} / {length}
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer
        className="border-0 d-flex justify-content-center justify-content-center  align-items-center ps-0 p-b-5 pe-0 pt-0 m-t-5"
        // style={{ justifyContent: "flex-end" }}
      >
        <div />
        <Button
          variant="secondary"
          className="height-25 d-flex align-items-center justify-content-center"
          onClick={handleClose}
        >
          Close
        </Button>
        <div />
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessAssignTaskModal;
